export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11196.634bc1dd.jpg";